import { Country, ErrorCode } from '@afterpaytouch/portal-api/types'
import { CheckoutError, InitialData, TerminalErrorCode } from '../../model'
import { isValidEmail } from '../validation'

export interface CheckoutValidation {
  statusCode?: number
  merchant: {
    supportedCountries: Country[]
  }
  crossRegionUserSignIn?: unknown
}

interface CheckoutValidatedInitialDataSuccess {
  error: null
  initialData: InitialData
}

interface CheckoutValidatedInitialDataError {
  error: CheckoutError
}

type CheckoutValidatedInitialData = CheckoutValidatedInitialDataSuccess | CheckoutValidatedInitialDataError

export const validateInitialData = (initialData: InitialData | null): CheckoutValidatedInitialData => {
  if (initialData === null) {
    return {
      error: {
        error: TerminalErrorCode.Default,
        errorCode: ErrorCode.InvalidToken,
      },
    }
  }
  return {
    error: null,
    initialData,
  }
}

export const validateCheckoutStatus = (checkout: CheckoutValidation): boolean => {
  // PAYL-6623 minimum not met error declined page
  // Please note that this statusCode is NOT a http status code. It's just a custom status code that
  // the backend has included in the body of the response.
  return checkout.statusCode === 402
}

export const validateMerchantCountry = (checkout: CheckoutValidation, country: Country): boolean => {
  // Merchant sent us to the wrong landing page :/
  return !checkout.merchant.supportedCountries.includes(country) && typeof checkout.crossRegionUserSignIn === 'undefined'
}

export const validateEmailFormat = (email: string): boolean => {
  return isValidEmail(email)
}
